module.exports = __webpack_public_path__ + "img/card_250890871.0400289f.jpg";